import {
  ContentLoader,
  Heading,
  PhoneField,
  PrimaryButton,
  useForm,
} from '@weave/design-system';
import { theme } from '@weave/theme';
import { FC } from 'react';
import { useQueryClient } from 'react-query';
import { OnboardingQueryKeys, useSendUserInviteSms } from '../onboarding.queries';
import { useSelector } from 'react-redux';
import { selectCurrentLocationId } from 'redux/actions/location';
import { useAlert } from '@weave/alert-system';
import { getParsedErrorMessage } from 'redux/axios';

export const SendUserInviteAction: FC = () => {
  const queryClient = useQueryClient();
  const locationId = useSelector(selectCurrentLocationId);
  const alert = useAlert();

  const { mutate: sendUserInviteSms, isLoading: isMutating } = useSendUserInviteSms({
    onSuccess: () => {
      alert.success('Invite link sent successfully');
      queryClient.invalidateQueries(
        OnboardingQueryKeys.getSentInviteLinkHistory({ locationId })
      );
    },
    onError: (error) => {
      const parsedError = getParsedErrorMessage(error);
      alert.error('Failed to send invite link: ' + parsedError);
      console.error(getParsedErrorMessage(error));
    },
  });

  const { formProps, getFieldProps, isComplete } = useForm({
    fields: {
      phoneNumber: { type: 'phone', required: true },
    },
    onSubmit: ({ phoneNumber }) => {
      sendUserInviteSms({
        phoneNumber,
        locationId,
      });
    },
  });

  return (
    <form
      css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1) }}
      {...formProps}
    >
      <ContentLoader show={isMutating} />
      <Heading level={3}>Send account creation link to mobile</Heading>
      <div css={{ display: 'flex', gap: theme.spacing(2) }}>
        <PhoneField
          label="Mobile Number"
          placeholder="Enter mobile number"
          {...getFieldProps('phoneNumber')}
        />
        <PrimaryButton
          disabled={!isComplete || isMutating}
          type="submit"
          css={{ maxWidth: 'max-content' }}
        >
          Send to Mobile
        </PrimaryButton>
      </div>
    </form>
  );
};
